import React, { Component } from "react";
import { Link } from "react-router";

class SignedupPage extends Component {
  render() {
    return (
      <div>
        <div className="max-w-2xl mx-auto px-4">
          <h1 className="text-3xl font-bold my-4">Signup Successful</h1>
          You have successfully signed up. In order to log in, you will need to verify the email
          address that you have provided. Please check your email (including any Spam folders), and
          click on the link provided. Once that's done, then please click{" "}
          <Link to="/login">Here</Link> to login.
        </div>
      </div>
    );
  }
}

export default SignedupPage;
